import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../../assets/images/logo.png";
import { getBusinessesList } from "../../../redux/reducers/businessSlice";
import { toast } from "react-toastify";

import "../../../assets/css/business.css";
import { FaCheckCircle } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { OverlayTrigger, ProgressBar, Tooltip } from "react-bootstrap";
import { Row, Col, Card, Button } from 'react-bootstrap';
import { LuMail, LuMapPin, LuLink2, LuQrCode, LuEllipsisVertical } from 'react-icons/lu';

export default function Businesslist() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Global fetching moved to App.js
  const businesslist = useSelector((state) => state.business.businessList);
  // console.log(businesslist);
  const getInitials = (name) => name?.charAt(0).toUpperCase() || "B";

  const handleCopyLink = (bizId) => {
    const link = `https://biz360.seventechsolution.com/customer-side/${bizId}/dashboard`;
    navigator.clipboard.writeText(link)
      .then(() => {
        toast.success("Customer-side link copied successfully!");
      })
      .catch(() => {
        toast.error("Failed to copy link.");
      });
  };

  return (
    <div className="container">
      <Row className="g-4">
        {businesslist.length > 0 ? (
          businesslist.map((biz) => (
            <Col key={biz._id} xs={12} md={6} lg={4} xl={3}>
              <Card className="business-card border-0 shadow-sm h-100 cursor-pointer">
                <Card.Body className="p-4 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <div className="biz-logo shadow-sm bg-soft-brand text-white d-flex align-items-center justify-content-center fw-bold">
                      {getInitials(biz.name)}
                    </div>
                    <div className="action-dots">
                      <LuEllipsisVertical className="text-muted cursor-pointer" />
                    </div>
                  </div>
                  <h5 className="fw-bold mb-1 cursor-pointer text-truncate" onClick={() => navigate(`/business-detail/${biz._id}`)} title={biz.name}>
                    {biz.name}
                  </h5>
                  <div className="d-flex align-items-start gap-2 text-muted mb-2">
                    <LuMail size={14} className="mt-1 flex-shrink-0" />
                    <span className="small text-truncate">{biz.contact?.email || 'No email set'}</span>
                  </div>
                  <div className="d-flex align-items-start gap-2 text-muted mb-4">
                    <LuMapPin size={16} className="mt-1 flex-shrink-0" />
                    <span className="small">{biz.location || 'Location not specified'}</span>
                  </div>
                  <div className="d-flex gap-2 border-top pt-3 mt-auto">
                    <Button 
                      variant="light" 
                      className="flex-grow-1 rounded-3 small fw-medium d-flex align-items-center justify-content-center gap-2 py-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCopyLink(biz._id);
                      }}
                    >
                      <LuLink2 size={16} /> Customer Link
                    </Button>
                    <Button variant="white" className="border rounded-3 p-2 shadow-sm d-flex align-items-center">
                      <LuQrCode size={18} className="text-muted" />
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))
        ) : (
          <Col xs={12} className="text-center py-5">
            <div className="p-5 bg-light rounded-4 text-center">
              <h5 className="text-muted">No businesses found</h5>
              <p className="small text-muted">Register your first business to start managing appointments.</p>
              {/* <Button variant="brand" className="rounded-pill mt-3" onClick={() => setShowModal(true)}>Add First Business</Button> */}
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
}
